import styled from 'styled-components';
import { flexPosition, fontStyle } from '../../styles/mixins';
import {
  GRAY_DARKER,
  GRAY_LIGHTER_2,
  FONT_SIZE_5,
  FONT_SIZE_6,
  FONT_WEIGHT_BOLD,
} from '../../styles/variables';
import Products from '../../images/icon_products.svg';

export const MenuItem = styled.div`
  width: 100%;
  margin: 0px auto !important;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
`;

export const MenuBody = styled.div`
  height: 80px;
  width: 100%;
  background: #fff;
  padding: 0px 20px;
  ${flexPosition({ align: 'center', justify: 'space-between' })}
`;

export const MenuName = styled.div`
  width: 40%;
  h2 {
    margin: 0;
    ${fontStyle(GRAY_DARKER, FONT_SIZE_5, FONT_WEIGHT_BOLD)}
  }
  opacity: ${({ notPublished }) => (notPublished ? '0.6' : '1')};
`;

export const MenuContent = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  flex-direction: row;
  width: 70%;
  padding-left: 20px;
`;

export const MenuFooter = styled.div`
  ${flexPosition({ align: 'center', justify: 'flex-start' })}
  height: 50px;
  background-color: ${GRAY_LIGHTER_2};
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  opacity: ${({ notPublished }) => (notPublished ? '0.6' : '1')};
`;

export const ContentDetail = styled.div`
    ${flexPosition({ align: 'center' })}
    opacity: ${({ notPublished }) => (notPublished ? '0.6' : '1')};
`;

export const PublishedLabel = styled.span`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  margin-left: 10px;
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
`;

export const IconProducts = styled.span`
  width: 25px;
  height: 25px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(${Products});
`;

export const DescribeProducts = styled.span`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_5, FONT_WEIGHT_BOLD)}
  text-transform: uppercase;
  margin-left: 10px;
`;



// WEBPACK FOOTER //
// ./src/components/MenuItem/style.js